module.exports = __webpack_public_path__ + "static/media/reticle.a051f775.svg";